import type {Key, Selection} from '@react-types/shared';

export const mapSelectionToKeysSet = (
  selection: Iterable<Key> | undefined,
): Selection => {
  return selection ? new Set(selection) : new Set();
};
